var Handlebars = require("../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var helper;

  return "        "
    + container.escapeExpression(((helper = (helper = helpers.CommunityID || (depth0 != null ? depth0.CommunityID : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"CommunityID","hash":{},"data":data}) : helper)))
    + " <span class=\"positive\">is unique</span>!\r\n";
},"3":function(container,depth0,helpers,partials,data) {
    return "        <span class=\"negative\">Someone already has this Knowledge Hub ID. Try another ID or <a href=\"\" class=\"show-options-link\">claim one of these...</a></span>\r\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.IsUnique : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data})) != null ? stack1 : "");
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./Scripts/templates/tooltips/suggestion-box-status.handlebars
// module id = 331
// module chunks = 1